import {component, EntityData, field, identifier} from "@fedeltapointofsale/data-client";
import {Markup_Type} from "../markup/markup.data";

export class InteractionMarkupData extends EntityData<InteractionMarkupData> {
    @field type: Markup_Type;
    @field value: number;

    get displayType(): number {
        return this.type == Markup_Type.FIXED_MARKDOWN && this.value == undefined ? Markup_Type.OPEN_FIXED_MARKDOWN
            : this.type == Markup_Type.PERCENT_MARKDOWN && this.value == undefined ? Markup_Type.OPEN_PERCENT_MARKDOWN
                : this.type;
    }
}

export class SurchargeInteractionData extends EntityData<SurchargeInteractionData> {
    @identifier surchargeId: number;
    @field name: string;
    @component modifier: InteractionMarkupData;
}

export class DiscountInteractionData extends EntityData<DiscountInteractionData> {
    @identifier discountId: number;
    @field name: string;
    @component modifier: InteractionMarkupData;
}

export class SurchargeDiscountInteractionData extends EntityData<SurchargeDiscountInteractionData> {
    @identifier interactionId: number;
    @component surcharge: SurchargeInteractionData;
    @component discount: DiscountInteractionData;
    @field surchargeUndiscountedPrice: boolean = false;
}

